<template>
  <div ref="Dashboardpdf" id="Dashboardpdf">
    <section class="dashboard">
      <div>
        <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
        <!-- <loading
          :active.sync="isLoading"
          loader="spinner"
          color="#36304a"
          :width="70"
        ></loading> -->
      </div>

      <b-card class="mainCardBG" v-if="showDash == true">
        <b-button @click="previousPage" size="sm" variant="light">
          <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
        </b-button>
        <b-row>
          <b-col md="3">
            <h4 class="page-title mb-1">TPT GR Dashboard</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <date-range-picker
              class="mb-1"
              :opens="openLeft"
              :always-show-calendars="showCal"
              v-model="dateRange"
              :startDate="startDate"
              :endDate="endDate"
              :locale-data="locale"
              @update="getDataTPTGRDashboard"
            >
            </date-range-picker>
          </b-col>
          <b-col md="2">
            <model-list-select
              :list="$store.getters['common/getAllClientList']"
              id="clientNamenew"
              v-model="clientIdFilter"
              option-value="clientId"
              option-text="clientName"
              placeholder="Select Client Name"
              @input="getDataTPTGRDashboard"
            ></model-list-select>
          </b-col>
          <b-col md="2">
            <model-list-select
              :list="transportTypeName"
              v-model="transportTypeFilter"
              option-value="transportTypeVal"
              option-text="transportTypeText"
              placeholder="Select Export / Import"
              @input="getDataTPTGRDashboard"
            ></model-list-select>
          </b-col>
          <b-col md="2" class="text-right" v-if="GRNDetails.length > 0">
            <b-button
              class="ml-3"
              :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
              @click="getReportsAss('Excel', 'TPTGRDashbord')"
              size="sm"
              variant="outline-info"
            >
              {{ ExcelBtnName }}
              <b-spinner
                v-if="ExcelBtnName != 'Export as Excel'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button>
          </b-col>
          <b-col md="2" class="text-right" v-if="GRNDetails.length > 0">
            <b-button
              v-if="GRNDetails.length > 0"
              class="ml-3"
              @click="exportGRNReportDashboard()"
              size="sm"
              variant="outline-info"
              >Export Vehicle GRN</b-button
            >
          </b-col>
        </b-row>
        <hr />
        <!-- <div class="gutr mt-3">
          <div class="row">
            <div
              v-if="ActiveVehicleGraph[0].data.length > 0"
              class="col-xl-12 col-md-12 grid-margin stretch-card mt-2"
            >
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h6 class="card-title">TOTAL Vehicle Used</h6>
                      <div class="fluid-container"></div>
                      <div id="chart">
                        <apexchart
                          v-if="ActiveVehicleGraph[0].data.length > 0"
                          type="bar"
                          class="mt-3"
                          height="550"
                          width="1000"
                          :options="chartOptionsActiveVehicleGraph"
                          :series="ActiveVehicleGraph"
                        ></apexchart>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr /> -->
        <div class="gutr mt-3">
          <div class="row">
            <div
              v-if="ActiveGenrateGRGraph[0].data.length > 0"
              class="col-xl-12 col-md-12 grid-margin stretch-card mt-2"
            >
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="">
                    <div>
                      <h6 class="card-title">Total GR Genrate</h6>
                      <div class="fluid-container">
                        <apexchart
                          v-if="ActiveGenrateGRGraph[0].data.length > 0"
                          type="bar"
                          class="mt-3"
                          height="800"
                          width="100%"
                          :options="chartOptionsGenrateGRGraph"
                          :series="ActiveGenrateGRGraph"
                        ></apexchart>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.box-header -->
            </div>
          </div>
        </div>
        <div class="row gutr"></div>
        <b-row>
          <b-table
            reg="GRNDetailsRef"
            :items="GRNDetails"
            :fields="fields"
            responsive
            primary-key="EDate"
            show-empty
            stacked="md"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
            class="position-relative"
          >
            <template slot="EDate" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
          </b-table>
          <!-- <table class="table table-sm table-bordered" v-if="GRNDetails.length > 0">
            <tbody style="background: white">
              <tr>
                <th scope="col">SN.</th>
                <th scope="col">Date</th>
                <th scope="col">Tot GRN</th>
                <th scope="col">Tot Active Vehicle</th>
              </tr>
              <tr v-for="(itm, idx) in GRNDetails" :key="idx">
                <th scope="row">{{ idx + 1 }}</th>
                <td>
                  <span v-if="itm.SDate">{{ itm.SDate }}</span>
                </td>
                <td>
                  <span v-if="itm.totalGRdata">{{ itm.totalGRdata }}</span>
                </td>
                <td>
                  <span v-if="itm.activeVehicle">{{ itm.activeVehicle }}</span>
                </td>
              </tr>
            </tbody>
          </table> -->
        </b-row>
        <div>
          <b-pagination
            aria-controlles="GRNDetails"
            limit="30"
            align="center"
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
            first-number
            last-number
          ></b-pagination>
        </div>
      </b-card>

      <b-card v-else class="mainCardBG">
        <b-navbar toggleable="lg" type="dark" variant="info">
          <b-navbar-brand v-if="showDash == false">
            <h4 class="page-title" v-if="employeeName != ''">
              Welcome <small>{{ employeeName }}</small>
            </h4>
          </b-navbar-brand>
        </b-navbar>
      </b-card>
    </section>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import DashboardService from "../../services/DashboardService.js";
import TrasportService from "../../services/TrasportService.js";
import { read, utils, writeFile } from "xlsx";
export default {
  beforeMount() {
    this.getCurrentLastDate();
    lastVisitPage(this.$router.history.current.fullPath);
    if (globalPermissionStatus("Dashboard_Access")) {
      this.$store.dispatch("setCurrentRoute", "/TPTGRdashboard");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.getDataTPTGRDashboard("0", "1", "1");
      }
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({
          itemCode: "ClientList",
        })
      );
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  mounted() {},

  beforeDestroy() {},
  destroyed() {},
  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
  },
  computed: {
    chartData() {
      // Combine day labels from x-axis and data points
      return this.chartOptions.xaxis.categories.map((day, index) => ({
        x: day,
        y: this.dataPoints[index],
      }));
    },
  },
  data() {
    return {
      ExcelBtnName: "Export as Excel",
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        },
        {
          transportTypeVal: "All",
          transportTypeText: "All",
        },
      ],
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      clientMaster: [],
      clientIdFilter: "",
      transportTypeFilter: "All",
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openLeft: "right",
      showCal: false,
      showDash: true,
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      employeeName: "",

      isLoading: false,
      chartOptions: {
        plotOptions: {
          pie: {
            // customScale: 1.0
            // size: 200
          },
        },
        chart: {
          width: 50,
          type: "pie",
        },
        labels: [],

        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 50,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
      seriesClientRev: [
        {
          name: "Ammount",
          data: [],
        },
      ],
      chartOptionsShippingLine: {
        annotations: {},
        chart: {
          height: 350,
          type: "bar",
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -30,
          },
          categories: [],
          tickPlacement: "on",
        },
        yaxis: {
          title: {
            text: "Ammount (INR)",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100],
          },
        },
      },

      chartOptionsClientReven: {
        annotations: {},
        chart: {
          height: 350,
          type: "bar",
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -30,
          },
          categories: [],
          tickPlacement: "on",
        },
        yaxis: {
          title: {
            text: "Ammount (INR)",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100],
          },
        },
      },

      chartOptionsConBar: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: true,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        xaxis: {
          categories: [],
        },
        legend: {
          position: "bottom",
          offsetY: 10,
        },
        fill: {
          opacity: 1,
        },
      },
      seriesExCom: [
        {
          name: "No.of Times Used",
          data: [],
        },
      ],
      chartOptionsExCom: {
        annotations: {},
        chart: {
          height: 350,
          type: "bar",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -35,
          },
          categories: [],
          tickPlacement: "off",
        },
        yaxis: {
          title: {
            text: "No. of Times Used",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100],
          },
        },
      },
      seriesShipBar: [
        {
          name: "No.of Container Shiped",
          data: [],
        },
      ],
      chartOptionsShipBar: {
        annotations: {},
        chart: {
          height: 350,
          type: "bar",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -35,
          },
          categories: [],
          tickPlacement: "on",
        },
        yaxis: {
          title: {
            text: "No. of Container Shipped",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100],
          },
        },
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      DateRangeContexecDataCount: [],
      ActiveGenrateGRGraph: [
        {
          name: "GR Genrate",
          data: [],
        },
        {
          name: "Active Vehicle",
          data: [],
        },
      ],
      chartOptionsExpClientGraph: {
        plotOptions: {
          line: {
            // customScale: 1.0
            // size: 200
          },
        },
        chart: {
          height: 350,
          type: "bar",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          width: [5, 7, 5],
          curve: "straight",
          dashArray: [0, 8, 5],
        },
        title: {
          text: "Total Vehicle Used for GR by Month",
          align: "left",
        },
        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return (
              val +
              " - " +
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
              ""
            );
          },
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function (val) {
                  return val + " ";
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val + " ";
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val;
                },
              },
            },
          ],
        },
      },
      // chartOptionsActiveVehicleGraph: {
      //   plotOptions: {
      //     line: {
      //       // customScale: 1.0
      //       // size: 200
      //     },
      //   },
      //   chart: {
      //     height: 150,
      //     width: 50,
      //     type: "bar",
      //     zoom: {
      //       enabled: false,
      //     },
      //   },
      //   dataLabels: {
      //     enabled: true,
      //   },
      //   stroke: {
      //     width: [2],
      //     curve: "straight",
      //     dashArray: [0, 8, 5],
      //   },
      //   title: {
      //     text: "Total Vehicle Used for GR by Month",
      //     align: "left",
      //   },
      //   legend: {
      //     tooltipHoverFormatter: function (val, opts) {
      //       return (
      //         val +
      //         " - " +
      //         opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
      //         ""
      //       );
      //     },
      //   },
      //   markers: {
      //     size: 0,
      //     hover: {
      //       sizeOffset: 6,
      //     },
      //   },
      //   grid: {
      //     row: {
      //       colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
      //       opacity: 0.5,
      //     },
      //   },
      //   xaxis: {
      //     categories: [],
      //   },
      //   tooltip: {
      //     y: [
      //       {
      //         title: {
      //           formatter: function (val) {
      //             return val + " ";
      //           },
      //         },
      //       },
      //       {
      //         title: {
      //           formatter: function (val) {
      //             return val + " ";
      //           },
      //         },
      //       },
      //       {
      //         title: {
      //           formatter: function (val) {
      //             return val;
      //           },
      //         },
      //       },
      //     ],
      //   },
      // },
      chartOptionsGenrateGRGraph: {
        chart: {
          type: "bar",
          height: 430,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
            // horizontal: true,
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: false,
          offsetX: -6,
          style: {
            fontSize: "12px",
            colors: ["#fff"],
          },
        },
        stroke: {
          show: true,
          width: 10,
          colors: ["transparent"],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: " (Count)",
          },
        },
        fill: {
          opacity: 8,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return " " + val + " Count";
            },
          },
        },
      },
      graphClinetName: null,
      GRNDetails: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 30,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      filter: null,
      sortDirection: "asc",
      docURL: URL_BASE_DOC,
      fields: [
        {
          key: "EDate",
          mainkey: "EDate",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "SDate",
          mainkey: "SDate",
          label: "Date",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "totalGRdata",
          mainkey: "totalGRdata",
          label: "TOT GRN",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "activeVehicle",
          mainkey: "activeVehicle",
          label: "Active Vehilce",
          sortable: true,
          sortDirection: "ASC",
        },
      ],
    };
  },
  methods: {
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },
    gotToFullClientReports() {
      this.$router.push({
        path: "/dashboard/clientProfile",
      });
    },
    changeNumberFormat(num) {
      if (num > 9999999) {
        return Math.abs(num) > 9999999
          ? Math.sign(num) * (Math.abs(num) / 10000000).toFixed(2) + " Crore"
          : Math.sign(num) * Math.abs(num);
      } else if (num > 99999) {
        return Math.abs(num) > 99999
          ? Math.sign(num) * (Math.abs(num) / 100000).toFixed(2) + " Lakhs"
          : Math.sign(num) * Math.abs(num);
      } else if (num > 999) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(2) + " Thousand"
          : Math.sign(num) * Math.abs(num);
      } else {
        return num;
      }
    },

    exportGRNReportDashboard() {
      if (this.GRNDetails.length > 0) {
        let newSheetdata = [];
        this.GRNDetails.map((obj, index) => {
          let SN = parseInt(index) + parseInt(1);
          let Per_Date = obj.SDate;
          let GRNCount = obj.totalGRdata;
          let activeVehicle = obj.activeVehicle;
          const newData = {
            SN: SN,
            Date: Per_Date,
            GRNCount: GRNCount,
            Vehicle: activeVehicle,
          };
          newSheetdata.push(newData);
        });
        let fileName = "ALL_Day_Wise_Vehicle_GRN_Count_LIST_Report_" + ".xlsx";
        const headings = [["SN", "Date", "GRNCount", "Vehicle"]];
        const wb = utils.book_new();
        const ws = utils.json_to_sheet([]);
        utils.sheet_add_aoa(ws, headings);
        utils.sheet_add_json(ws, newSheetdata, { origin: "A2", skipHeader: true });
        utils.book_append_sheet(wb, ws, "Report");
        writeFile(wb, fileName);
      }
    },
    previousPage() {
      window.history.go(-1);
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.getDataTPTGRDashboard("0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.getDataTPTGRDashboard("0", CURRENT, "2", event);
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getDataTPTGRDashboard() {
      this.isLoading = true;
      // this.chartOptionsActiveVehicleGraph = {
      //   plotOptions: {
      //     line: {
      //       // customScale: 1.0
      //       // size: 200
      //     },
      //   },
      //   chart: {
      //     height: 150,
      //     width: 50,
      //     type: "bar",
      //     zoom: {
      //       enabled: false,
      //     },
      //   },
      //   dataLabels: {
      //     enabled: true,
      //   },
      //   stroke: {
      //     width: [2],
      //     curve: "straight",
      //     dashArray: [0, 8, 5],
      //   },
      //   title: {
      //     text: "Total Vehicle Used for GR by Month",
      //     align: "left",
      //   },
      //   legend: {
      //     tooltipHoverFormatter: function (val, opts) {
      //       return (
      //         val +
      //         " - " +
      //         opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
      //         ""
      //       );
      //     },
      //   },
      //   markers: {
      //     size: 0,
      //     hover: {
      //       sizeOffset: 6,
      //     },
      //   },
      //   grid: {
      //     row: {
      //       colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
      //       opacity: 0.5,
      //     },
      //   },
      //   xaxis: {
      //     categories: [],
      //   },
      //   tooltip: {
      //     y: [
      //       {
      //         title: {
      //           formatter: function (val) {
      //             return val;
      //           },
      //         },
      //       },
      //     ],
      //   },
      // };
      // this.ActiveVehicleGraph = [
      //   {
      //     name: "Active Vehicle",
      //     data: [],
      //   },
      // ];
      this.chartOptionsGenrateGRGraph = {
        chart: {
          type: "bar",
          height: 430,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
            // horizontal: true,
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: false,
          offsetX: -6,
          style: {
            fontSize: "12px",
            colors: ["#fff"],
          },
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: " (Count)",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return " " + val + " Count";
            },
          },
        },
      };
      this.ActiveGenrateGRGraph = [
        {
          name: "GR Genrate",
          data: [],
        },
        {
          name: "Active Vehicle",
          data: [],
        },
      ];
      this.GRNDetails = [];

      let type_Size = {
        TPTGR: "TPTGR",
        dateRange: this.dateRange,
        clientIdFilter: this.clientIdFilter,
        transportTypeFilter: this.transportTypeFilter,
      };
      console.log("type_Size => ", type_Size);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/getTPTGRDashboard.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            // console.log("Priyanshu Singh=>",data);
            let date = new Date(); // 2020-06-21
            //alert(date);
            let shortMonth = date.toLocaleString("en-us", {
              month: "short",
            }); /* June */

            if (data.GRNDetails.length > 0) {
              this.chartOptionsGenrateGRGraph.xaxis.categories = [];
              data.GRNDetails.forEach((element) => {
                this.chartOptionsGenrateGRGraph.xaxis.categories.push(element.SDate);
                this.ActiveGenrateGRGraph[0].data.push(element.totalGR);
                this.ActiveGenrateGRGraph[1].data.push(element.activeVehicle);
              });
              this.GRNDetails = data.GRNDetails;
              this.totalRows = data.GRNDetails.length;
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    getReportsAss(type, subtype) {
      this.isLoading = true;
      let payload = {
        excelId: "Master_GRN_List",
        type: type,
        subtype: subtype,
        dateRange: this.dateRange,
        clientIdFilter: this.clientIdFilter,
        transportTypeFilter: this.transportTypeFilter,
      };
      this.ExcelBtnName = "Downloading Please Wait....";
      TrasportService.getAllGRN_List(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.isLoading = false;
            if (subtype == "TPTGRDashbord") {
              this.ExcelBtnName = "Export as Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            }
          }
        })
        .catch((error) => {
          console.log("Catch on All_GRN_List Error: ", error);
        });
    },
  },
};
</script>

<style scoped>
.topFiveHeight {
  height: 315px !important;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-top: 1px solid #ffffff !important;
}
.mainCard {
  display: flex;
  margin-bottom: 2rem;
  justify-content: space-between;
  padding: 0;
  border-radius: 10px;
  position: relative;
  min-height: 50px;
  border-bottom: 1px solid #eee !important;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: none !important;
}
.page-header {
  display: flex;
  align-items: center;
  margin: 1.5rem 2rem 1.5rem;
  justify-content: space-between;
  padding: 0;
  border-radius: 3px;
  position: relative;
  min-height: 50px;
  border-bottom: 1px solid #eee !important;
}
.page-title {
  margin: 0;
  font-size: 25px;
  font-weight: 600;
  line-height: 2.5rem;
  position: relative;
  color: #2f2752;
}
.subpage-title {
  font-weight: 300;
  color: #43377b;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.topDivCard {
  margin: 1.5rem 2rem 1.5rem;

  position: relative;

  display: flex;

  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  box-shadow: -8px 12px 18px 0 rgba(25, 42, 70, 0.13);
  border-radius: 3px;
  border: 1px solid transparent;
  margin-bottom: 1.5rem;
  width: 100%;
}
.mb-3 {
  margin: 1.5rem 1rem 1.5rem;
  margin-bottom: 0rem !important;
  font-weight: 600 !important;
  color: #2f2752;
}
.mb-2 {
  margin-bottom: 0 !important;
  font-weight: 700 !important;
}
.mb-4 {
  margin-bottom: -0.5rem !important;
  font-weight: 700 !important;
}
.col-lg-6 {
  width: 49%;
}
.col-lg-4 {
  width: 32.6%;
}
</style>



// WEBPACK FOOTER //
// tptGRDashboard.vue?0da84420